import { motion } from 'framer-motion';
import { Smartphone, Camera, FileText, CheckCircle, ArrowRight } from 'lucide-react';

export default function Overview() {
  const steps = [
    {
      icon: Smartphone,
      title: 'Start Session',
      description: 'Quickly initiate a verification session via direct link or QR code handoff from desktop to mobile.',
    },
    {
      icon: Camera,
      title: 'Live Capture',
      description: 'Real-time image quality feedback ensures clear ID and liveness photos for maximum accuracy.',
    },
    {
      icon: FileText,
      title: 'AI Analysis',
      description: 'Automated OCR extraction and biometric face matching processed in seconds.',
    },
    {
      icon: CheckCircle,
      title: 'Instant Result',
      description: 'Receive immediate verification results with a cryptographically signed audit trail.',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-900 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <img src="/Agos_logo.png" alt="Agos Logo" className="h-16 h-16 mx-auto mb-6" />
          <h1 className="text-4xl font-bold text-white mb-4">Product Overview</h1>
          <p className="text-xl text-gray-400">
            The most advanced eKYC solution built specifically for the Philippine market.
          </p>
        </motion.div>

        <div className="space-y-12 mb-20">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="flex flex-col md:flex-row items-center gap-8 bg-gray-800/30 p-8 rounded-3xl border border-gray-700/40"
            >
              <div className="w-20 h-20 bg-blue-500/20 rounded-2xl flex items-center justify-center shrink-0">
                <step.icon className="w-10 h-10 text-blue-400" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-3">Step {index + 1}: {step.title}</h3>
                <p className="text-gray-400 text-lg leading-relaxed">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="text-center bg-gradient-to-r from-blue-600 to-blue-500 p-12 rounded-3xl shadow-xl"
        >
          <h2 className="text-3xl font-bold text-white mb-6">Ready to Experience Agos?</h2>
          <p className="text-blue-100 text-lg mb-8 max-w-lg mx-auto">
            Get started today with our basic plan or contact sales for custom enterprise integrations.
          </p>
          <div className="flex justify-center gap-4">
            <button className="bg-white text-blue-600 px-8 py-3 rounded-xl font-bold hover:bg-gray-100 transition-colors">
              Get Started
            </button>
            <button className="border border-white/30 text-white px-8 py-3 rounded-xl font-bold hover:bg-white/10 transition-colors">
              Contact Us
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
